var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeCounter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98657 12.2334L7.05324 13.8334C7.31991 14.1001 7.91991 14.2334 8.31991 14.2334H10.8532C11.6532 14.2334 12.5199 13.6334 12.7199 12.8334L14.3199 7.96673C14.6532 7.03339 14.0532 6.23339 13.0532 6.23339H10.3866C9.98657 6.23339 9.65324 5.90006 9.71991 5.43339L10.0532 3.30006C10.1866 2.70006 9.78657 2.03339 9.18657 1.83339C8.65324 1.63339 7.98657 1.90006 7.71991 2.30006L4.98657 6.36673",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58667 12.2333V5.70002C1.58667 4.76668 1.98667 4.43335 2.92 4.43335H3.58667C4.52 4.43335 4.92 4.76668 4.92 5.70002V12.2333C4.92 13.1667 4.52 13.5 3.58667 13.5H2.92C1.98667 13.5 1.58667 13.1667 1.58667 12.2333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeCounter);
export default __webpack_public_path__ + "static/media/like-counter.63d19beb968783ee21908c4ec4759eed.svg";
export { ForwardRef as ReactComponent };